export default __webpack_public_path__ + "6f51688fcf7ccc6eb8fbf18fdb0dc180.png";